import {Component, ViewEncapsulation, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TooltipService } from "@irb/irb-common/components/tooltip/tooltip.service";
import { AppService } from "@irb/app.service";
import { IrbSettingsEvents, IEvent, IrbAppEvents } from "@irb/irb-common/events";
import { Subscription } from "rxjs";

@Component({ standalone: false,
    templateUrl: './morningstar-categories-automatic-mapping-dialog.html',
    styleUrls: ['./morningstar-categories-automatic-mapping-dialog.scss', '../../../irb-common/styles/dialog.scss'],
    encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MorningstarCategoriesAutomaticMappingDialogComponent implements OnDestroy {

  @Output() saveFunction = new EventEmitter<boolean>();
  eventSubscription: Subscription;
  securitiesExisting: string;
  modalDescription: string;
    constructor(public dialogRef: MatDialogRef<MorningstarCategoriesAutomaticMappingDialogComponent>, public as: AppService,
      public tts: TooltipService,) {
        this.eventSubscription = this.as.getEvents().subscribe((s) => { this.processEvent(s); });

        this.modalDescription = "As you add new mutual funds and ETFs to your security master, they will be automatically mapped to their appropriate categories as defined by Morningstar. Your existing securities will remain as you've already categorized them.";
    }
    
    processEvent(event: IEvent) {
      switch(event.type) {
        case IrbSettingsEvents.SECURITY_EXISTING: 
        if(event.data == "OverrideingExistingCategories") {
          this.securitiesExisting = "To all securities";
          this.modalDescription = 'All of your mutual funds and ETFs – new and existing ones – will be automatically mapped<br>' +
              'to their appropriate categories as defined by Morningstar.<br>' +
              '<b>This process cannot be undone.</b>';
        } else if(event.data == "UpdateUncategorizedSecurities") {
          this.securitiesExisting = "To uncategorized securities only";
          this.modalDescription = 'Any mutual funds and ETFs you have that are not currently categorized will be automatically<br>' +
              'mapped to their appropriate categories as defined by Morningstar.<br>' +
              '<b>This process cannot be undone.</b>';
        } else if(event.data == "ApplyToNewSecuritiesOnly") {
          this.securitiesExisting = "To all securities going forward only (existing values remain)";
        }
          break;
      }
    }

    close() {
        this.dialogRef.close();
      }
    continue() {    
      this.as.fireEvent(IrbSettingsEvents.SAVE_WITHOUT_MORNING_STAR, this.saveFunction);
     // this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      this.saveFunction.emit(true);
      this.dialogRef.close();
    }

    ngOnDestroy(): void {
      if (this.eventSubscription)
        this.eventSubscription.unsubscribe();
    }
}
